export const medicamentos = state => {
	const meds = {};
	state.medicamentos.forEach(medicamento => {
		meds[medicamento.id] = medicamento;
	});
	return meds;
};
